import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";

//Redux
import { useSelector } from "react-redux";
import { InputField } from "../../../../Components/formElements/InputField";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import CashExpensesPrintOut from "./CashExpensesPrintOut";
import { useReactToPrint } from "react-to-print";
const CashExpensesDetails = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Indent");

  let cashExpensesNr = useSelector(
    (state) => state?.customer?.cashExpenses?.cashExpensesNr
  ); // User Details from Store
  const pageStyle = `
  @page {
    size: A4 portrait; /* Sets the paper size to A3, in portrait orientation */
    margin: 10mm;     /* Optional: Sets a small margin for the page */
  }
 
  /* Optional: Targeting the body inside the print document for better fill */
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;

  const [formInputs, setFormInputs] = useState({});
  // const [backDataObj2, setBackDataObj2] = useState({});
  const [isCardVisible, setCardVisible] = useState(true);
  // View attachment file
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const loadFirstLevelData = async (page) => {
    if (cashExpensesNr) {
      let obj = {
        documentNumber: cashExpensesNr,
      };
      await ItemService.getCustInvoiceDetail(obj).then((item) => {
        // console.log(item);
        if (item?.status === 200) {
          setDisabledStatus(true);
          setFormInputs(item?.data[0]);
          // setBackDataObj2(item?.data[1]);

          //   setPOLineItemsData(item?.data[0]?.items);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
      navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const firstItem =
    formInputs?.items && formInputs.items.length > 0
      ? formInputs.items[0]
      : null;

  const amountToShow = firstItem
    ? firstItem.debitAmount === 0
      ? firstItem.creditAmount
      : firstItem.creditAmount === 0
      ? firstItem.debitAmount
      : firstItem.creditAmount || firstItem.debitAmount || ""
    : "";

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  //Print Out

  // send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();
  // eslint-disable-next-line
  const [getInvoiceChildData, setInvoiceChildData] = useState();
  // eslint-disable-next-line
  const [showPrint, setShowPrint] = useState(false);

  const printInvoiceDataChild = (childdData) => {
    setInvoiceChildData(childdData);
    // console.log(">>Received childdData from child:", childdData);
    // You can now use this data in the parent component
  };

  useEffect(() => {
    setPrintInvoiceData(formInputs);
  }, [formInputs]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    // documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    documentTitle: `Voucher`,
    onAfterPrint: () => setShowPrint(false),
    pageStyle: pageStyle,
  });

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              Cash Expenses Details :{" "}
              {/* <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {cashExpensesNr}
              </span> */}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.voucherNumber || formInputs?.cashRequestNr}
              </span>
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.transactionId}
              </span>
            </h2>
            <p className="subText">Cash Expenses</p>
            <hr />
            <div /* style={{ display: "none" }} */ className="d-none">
              <CashExpensesPrintOut
                ref={contentRef}
                data={printInvoiceData}
                onsendinvoicedata={printInvoiceDataChild}
              />
            </div>

            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CE</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Cash Expenses</span>
                      <span className="subHeaderTitle">Cash Expenses</span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="text-left">
                      {/* <button className="btnBack" onClick={handlePrint}> */}
                      <button
                        className="btn btnTable"
                        onClick={() => {
                          setShowPrint(true);
                          setTimeout(handlePrint, 0); // ensure component mounts first
                        }}
                      >
                        <i class="bi bi-upload mx-2"></i>
                        Export
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyCodeDesc"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.companyCodeDesc || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      {formInputs?.cashType === "CR" ? (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer/Vendor/Employee"
                              name="customerCodeDesc"
                              extraLabel=""
                              placeholder=""
                              value={formInputs?.customerName ||formInputs?.salesOfficerName ||""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer/Employee"
                              name="customerCodeDesc"
                              extraLabel=""
                              placeholder=""
                              value={formInputs?.customerCodeDesc || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </>
                      )}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Date"
                          name="bankTransactionDate"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.bankTransactionDate || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Expenses Head"
                          name="expensesHead"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.expensesHead || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Type"
                          name="type"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.type || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Amount"
                          name="amount"
                          value={amountToShow}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                          placeholder="Enter Amount"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Remarks"
                          name="remarks"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.remarks || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="d-block">
              <CashExpensesPrintOut
                ref={contentRef}
                data={printInvoiceData}
                onsendinvoicedata={printInvoiceDataChild}
              />
            </div> */}
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CashExpensesDetails;
